import React, { useState, useEffect } from 'react';
import { FaPlus } from "react-icons/fa6";
import { AiOutlineEdit } from "react-icons/ai";
import { RiDeleteBin6Line } from "react-icons/ri";
import PopupModel from '../components/popupModel';
import "../pages/withdrawalSettings.css"

// Images
import BankImg from '../assets/images/bank.png';

const WithdrawalSettings = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [bankDetails, setBankDetails] = useState([]);
    const [formData, setFormData] = useState({
        accountHolder: '',
        bankName: '',
        accountNumber: '',
        ifscCode: ''
    });
    const storedUserName = localStorage.getItem('loggedUser');
    const userBankDetails = JSON.parse(localStorage.getItem('userBankDetails'));

    // Load bank details from localStorage on component mount
    useEffect(() => {
        const storedBanks = JSON.parse(localStorage.getItem('bankDetails')) || [];
        setBankDetails(storedBanks);
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.accountHolder || !formData.bankName || !formData.accountNumber || !formData.ifscCode) {
            alert("Please fill all fields");
            return;
        }
        const updatedBanks = [...bankDetails, formData];
        setBankDetails(updatedBanks);
        localStorage.setItem('bankDetails', JSON.stringify(updatedBanks)); // Store in localStorage
        setFormData({ accountHolder: '', bankName: '', accountNumber: '', ifscCode: '' });
        setIsOpen(false);
    };

    return (
        <div className='w-full md:w-[80%] min-h-screen mx-auto p-4'>

            <PopupModel isOpen={isOpen} setIsOpen={setIsOpen} size="small" popupFor="Add Bank Details">
                <div className="mx-auto bg-white p-6 rounded-2xl shadow-lg">
                    <form className="space-y-4" onSubmit={handleSubmit}>
                        <div>
                            <label className="block text-gray-700 font-medium">Account Holder Name :</label>
                            <input
                                type="text"
                                name="accountHolder"
                                value={formData.accountHolder}
                                onChange={handleChange}
                                placeholder="Enter your name"
                                className="w-full bg-gray-100 mt-1 p-3 border rounded-xl focus:ring-2 focus:ring-violet-700 focus:outline-none placeholder-with-star"
                            />
                        </div>

                        <div>
                            <label className="block text-gray-700 font-medium">Bank Name :</label>
                            <select
                                name="bankName"
                                value={formData.bankName}
                                onChange={handleChange}
                                className="w-full mt-1 bg-gray-100 p-3 border rounded-xl focus:ring-2 focus:ring-violet-700 focus:outline-none"
                            >
                                <option value="">Select Bank</option>
                                <option value="HDFC Bank">HDFC Bank</option>
                                <option value="State Bank of India">State Bank of India</option>
                                <option value="ICICI Bank">ICICI Bank</option>
                                <option value="Axis Bank">Axis Bank</option>
                                <option value="Kotak Mahindra Bank">Kotak Mahindra Bank</option>
                                <option value="Punjab National Bank">Punjab National Bank</option>
                                <option value="Bank of Baroda">Bank of Baroda</option>
                                <option value="Union Bank of India">Union Bank of India</option>
                                <option value="IndusInd Bank">IndusInd Bank</option>
                                <option value="IDFC First Bank">IDFC First Bank</option>
                            </select>
                        </div>

                        <div>
                            <label className="block text-gray-700 font-medium">Account Number :</label>
                            <input
                                type="text"
                                name="accountNumber"
                                value={formData.accountNumber}
                                onChange={handleChange}
                                placeholder="Enter account number"
                                className="w-full mt-1 bg-gray-100 p-3 border rounded-xl focus:ring-2 focus:ring-violet-700 focus:outline-none placeholder-with-star"
                            />
                        </div>

                        <div>
                            <label className="block text-gray-700 font-medium">IFSC Code :</label>
                            <input
                                type="text"
                                name="ifscCode"
                                value={formData.ifscCode}
                                onChange={handleChange}
                                placeholder="Enter IFSC code"
                                className="w-full mt-1 p-3 bg-gray-100 border rounded-xl focus:ring-2 focus:ring-violet-700 focus:outline-none placeholder-with-star"
                            />
                        </div>

                        <button
                            type="submit"
                            className="w-full text-[18px] bg-violet-800 text-white py-4 rounded-xl font-bold hover:bg-violet-900 transition"
                        >
                            SUBMIT
                        </button>
                    </form>
                </div>
            </PopupModel>

            <h3 className='text-2xl md:text-[30px] text-center font-bold text-gray-600 mb-4'>WITHDRAWAL SETTINGS</h3>
            <p className='text-gray-600 text-center'>All the options you have or can create to</p>
            <p className='text-gray-600 text-center'>withdraw from your account</p>

            {/* Filter and Add Setting Button */}
            <div className='flex flex-col md:flex-row items-center justify-between gap-4 mt-6'>
                <select className='text-base md:text-[20px] text-gray-600 bg-[#F3F3FF] w-full md:w-[20%] p-2 md:p-4 rounded-[10px] border-2'>
                    <option selected value="">All</option>
                    <option value="">Bank</option>
                    <option value="">UPI</option>
                    <option value="">NEFT</option>
                    <option value="">RTGS</option>
                    <option value="">IMPS</option>
                </select>

                <div onClick={() => setIsOpen(true)} className='bg-violet-700 hover:bg-violet-800 duration-300 cursor-pointer text-base md:text-[20px] flex items-center gap-2 text-white px-4 md:px-8 py-2 md:py-4 rounded-[10px] w-full md:w-auto justify-center'>
                    <FaPlus size={20} className='cursor-pointer text-white' />
                    <span>Add Setting</span>
                </div>
            </div>

            <div className='bg-white shadow-md border-2 gap-4 md:gap-5 mt-6 md:mt-[30px] flex flex-col md:flex-row items-center justify-between rounded-[10px] p-4 md:p-8'>
                <div className='flex items-center gap-4'>
                    <img className='w-16 h-16 md:w-20 md:h-20 rounded-full' src={BankImg} alt="Bank" />
                    <div className='flex flex-col'>
                        <p className='text-lg md:text-[20px] mb-0 font-medium'>Bank</p>
                        <p className='text-lg md:text-[20px] mb-0 font-medium'>
                            {userBankDetails?.bank_name || 'N/A'}
                        </p>
                        <p className='text-sm md:text-[16px] mb-0 text-gray-500'>
                            {userBankDetails?.name || 'N/A'}{' '}
                            {userBankDetails?.bank_account_number
                                ? `(**********${userBankDetails.bank_account_number.slice(-4)})`
                                : ''}
                        </p>
                    </div>

                </div>

                <div className='flex items-center gap-4'>
                    <div className='w-[60px] md:w-[80px] flex items-center justify-center border-e-[3px] h-[50px] md:h-[70px]'>
                        <AiOutlineEdit size={25} className='cursor-pointer text-gray-500 hover:text-gray-900 duration-300' />
                    </div>
                    <div className='ms-3'>
                        <RiDeleteBin6Line size={25} className='cursor-pointer text-gray-500 hover:text-gray-900 duration-300' />
                    </div>
                </div>
            </div>


            {/* Bank Cards List */}
            {bankDetails.length ? bankDetails.map((bank, index) => (
                <div key={index} className='bg-white shadow-md border-2 gap-4 md:gap-5 mt-6 md:mt-[30px] flex flex-col md:flex-row items-center justify-between rounded-[10px] p-4 md:p-8'>
                    <div className='flex items-center gap-4'>
                        <img className='w-16 h-16 md:w-20 md:h-20 rounded-full' src={BankImg} alt="Bank" />
                        <div className='flex flex-col'>
                            <p className='text-lg md:text-[20px] mb-0 font-medium'>Bank</p>
                            <p className='text-lg md:text-[20px] mb-0 font-medium'>{bank.bankName}</p>
                            <p className='text-sm md:text-[16px] mb-0 text-gray-500'>{bank.accountHolder} {`(**********${bank.accountNumber.slice(-4)})`}</p>
                        </div>
                    </div>

                    <div className='flex items-center gap-4'>
                        <div className='w-[60px] md:w-[80px] flex items-center justify-center border-e-[3px] h-[50px] md:h-[70px]'>
                            <AiOutlineEdit size={25} className='cursor-pointer text-gray-500 hover:text-gray-900 duration-300' />
                        </div>
                        <div className='ms-3'>
                            <RiDeleteBin6Line size={25} className='cursor-pointer text-gray-500 hover:text-gray-900 duration-300' />
                        </div>
                    </div>
                </div>
            )) :
                <div className='text-center text-gray-500 text-lg mt-[50px] md:text-[20px]'></div>
            }
        </div>
    );
};

export default WithdrawalSettings;
